const services = [
  {
    name: "Facebook",
    logo: require("./img/icons/facebook-logo.png")
  },
  {
    name: "WhatsApp",
    logo: require("./img/icons/whatsapp-logo.png")
  },
  {
    name: "Vk",
    logo: require("./img/icons/vk-logo.png")
  },
  {
    name: "Telegram",
    logo: require("./img/icons/telegram-logo.png")
  },
  {
    name: "Steam",
    logo: require("./img/icons/steam-logo.png")
  },
  {
    name: "Google",
    logo: require("./img/icons/google-logo.png")
  },
  {
    name: "OK.ru",
    logo: require("./img/icons/ok-ru.png")
  },
  {
    name: "Yandex",
    logo: require("./img/icons/yandex-logo.png")
  },
  {
    name: "Airbnb",
    logo: require("./img/icons/airbnb.png")
  },
  {
    name: "WeChat",
    logo: require("./img/icons/wechat.png")
  },
  {
    name: "AOL",
    logo: require("./img/icons/aol-logo.png")
  },
  {
    name: "Paypal",
    logo: require("./img/icons/paypal-logo.png")
  },
  {
    name: "icq",
    logo: require("./img/icons/icq-logo.png")
  },
  {
    name: "Amazon",
    logo: require("./img/icons/amazon-logo.png")
  },
  {
    name: "Mail.ru",
    logo: require("./img/icons/mailru-logo.png")
  },
  {
    name: "Instagram",
    logo: require("./img/icons/instagram-logo.png")
  },
  {
    name: "Microsoft",
    logo: require("./img/icons/microsoft.png")
  },
  {
    name: "LinkedIn",
    logo: require("./img/icons/linkedin-logo.png")
  },
  {
    name: "Tinder",
    logo: require("./img/icons/tinder-logo.png")
  },
  {
    name: "Uber",
    logo: require("./img/icons/uber-logo.png")
  },
  {
    name: "Twitter",
    logo: require("./img/icons/twitter-logo.png")
  },
  {
    name: "Line",
    logo: require("./img/icons/line.png")
  },
  {
    name: "Webmoney",
    logo: require("./img/icons/webmoney.png")
  },
  {
    name: "Viber",
    logo: require("./img/icons/viber-logo.png")
  },
];

module.exports = services;
